import React, { useState, useEffect } from 'react';
import { useNavigate } from '@thd-olt-component-react/router';
import { CompareTray } from '../components/compare-tray/CompareTray';
import { extend } from '@thd-nucleus/data-sources';

export const CompareTrayComposable = () => {
  let navigate = useNavigate();
  const [selectedForCompare, setSelectedForCompare] = useState([]);

  const onSelectionChange = ({ output }) => {
    const { selectedItems } = output || {};
    if (!selectedItems) return;
    setSelectedForCompare(selectedItems);
  }

  useEffect(() => {
    const itemIds = window.sessionStorage.getItem('compare');
    if (itemIds) {
      setSelectedForCompare(JSON.parse(itemIds));
    }
    window.LIFE_CYCLE_EVENT_BUS.on('PLP_CompareTray.selection', onSelectionChange);
  }, []);

  const onSelectedForCompare = (itemId) => {
    if (window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('PLP_CompareTray.removal', { itemId: itemId });
    }
  };

  const onCompare = () => {
    const queryParams = selectedForCompare
      .map((itemId, index) => `item${index + 1}=${itemId}`)
      .join('&');
    navigate(`/compare?${queryParams}`, { state: { bypassExperienceCheck: true } });
  }

  return (
    <CompareTray
      itemIds={selectedForCompare}
      onRemove={onSelectedForCompare}
      onCompare={onCompare}
    />)

};

CompareTrayComposable.displayName = 'CompareTrayComposable';
CompareTrayComposable.dataModel = extend(CompareTray);